import React, {Component, ReactNode} from 'react'
import ResidentMeetingAttendanceForm from './ResidentMeetingAttendanceForm'
import NewMeetingAttendanceResponse from './model/NewMeetingAttendanceResponse'
import {ErrorResponseBody} from '../../network/response/ErrorResponseBody'
import {MeetingRepositoryForResident} from './MeetingRepositoryForResident'
import {NatAsyncCallFunction} from '../../__NoAutomatedTests/common/util/Natutil'
import EventEmitterExResident from '../shared/pageBaseComponents/EventEmitterExResident'
import {HttpError} from '../../network/errors/HttpError'
import {AVAILABLE_OR_NOT} from '../../CodeMaster'
import {NavigateFunction} from 'react-router-dom'

interface Props {
    condominiumCd: string
    meetingId: number
    meetingName: string
    meetingDateString: string
    meetingPlaceString: string
    proxyAttendanceAvailability: AVAILABLE_OR_NOT
    meetingRepo: MeetingRepositoryForResident
    eventEmitter: EventEmitterExResident
    navigate: NavigateFunction
    onClose: (isOk: boolean) => void
}

export default class ResidentRegisterMeetingAttendanceDialog extends Component<Props> {
    constructor(props: Readonly<Props>) {
        super(props)

        this.handleClickSubmit = this.handleClickSubmit.bind(this)
    }

    async handleClickSubmit(meetingAttendance: NewMeetingAttendanceResponse)
        : Promise<'success' | 'communicationError' | ErrorResponseBody> {

        await this.props.eventEmitter.showLoading()
        try {
            const result = await NatAsyncCallFunction(
                this.props.meetingRepo.registerAttendance.bind(
                    this.props.meetingRepo,
                    this.props.condominiumCd,
                    this.props.meetingId,
                    meetingAttendance,
                ),
                this.props.navigate,
            )
            if (result === null) {
                return 'communicationError'
            }
        } catch (e) {
            return (e as HttpError).responseBody
        } finally {
            this.props.eventEmitter.closeLoading()
        }

        return 'success'
    }

    render(): ReactNode {
        return <ResidentMeetingAttendanceForm
            meetingName={this.props.meetingName}
            meetingDateString={this.props.meetingDateString}
            meetingPlaceString={this.props.meetingPlaceString}
            proxyAttendanceAvailability={this.props.proxyAttendanceAvailability}
            originalData={null}
            submitButtonLabel={'回答する'}
            readOnly={false}
            onClose={this.props.onClose}
            onSubmit={this.handleClickSubmit}
        />
    }
}
